import Layout from '../components/Layout';
import '../css/HotTopicsPage.css';
import HotTopicsFeed from '../UI-Components/HotTopicsFeed/HotTopicsFeed';

const HotTopicsPage = () => {
  return (
    <Layout pageTitle="Hot Topics &#x1F525;">
      <HotTopicsFeed />
    </Layout>
  );
};

export default HotTopicsPage;